import axios from 'axios'
import {resetAuth, setAuth, setCompanies} from './../../utils/auth'
import {API_SERVER, AUTHORIZATION,  token, BASE_URL} from './../../constants/constants'

const state = {
  user: null,
  companies: [],
  accessToken: token,
  currentToken: localStorage.getItem(AUTHORIZATION),
  errorStr : ''
}
const mutations = {
  setAuth (state, data) {
    state.currentToken = data
  },
  setCompanies (state, data) {
    state.companies = data
  },
  setUser (state, data) {
    state.user = data
  },
  resetUser (state) {
    state.user = null
    state.currentToken = null
    state.companies =null
  }
}
const actions = {
  async fetch ({commit, dispatch}, param) {
    if (!param) {
      return null
    }
    let { data } = await axios({
      url: 'user_details',
      headers: {
        'accessToken': token,
        'x-auth': param
      },
      baseURL: API_SERVER + BASE_URL
    })
    if (data && data.success === true) {
      const user = {
        full_name: data.data.full_name
      }
      commit('setUser', user)
      commit('setAuth', param)
      setAuth(param)
    } else {
      dispatch('resetAuth')
    }
    return data
  },
  login ({commit}, param) {
    return axios.post('/email_login', param)
      .then(response => {
        const {data} = response
        if (data && data.success === true) {
          commit('setAuth', data.data.token)
          setAuth(data.data.token)
        }
        return response
      })
  },
  async getCompaniesList({commit, dispatch}, param) {
    if (!param) {
      return null
    }
    let {data} = await axios({
      url: 'list_companies',
      headers: {
        'accessToken': token,
        'x-auth': param
      },
      baseURL: API_SERVER + BASE_URL
    })
    if (data && data.success === true) {
      commit('setCompanies', data.data.list)
      setCompanies(data.data.list)
    } else {
      dispatch('resetAuth')
    }
    return data
  },
  async loginByCompany({commit, dispatch}, param) {
    let { data } = await  axios.post('/select_company', param, {
      headers: {
        'accessToken': token,
        'x-auth': localStorage.getItem('x-auth'),
      },
    })
    if (data && data.success === true) {
      commit('setAuth', data.data.token)
      setAuth(data.data.token)
    } else {
      dispatch('resetAuth')
    }

    return data


  },
  logout () {
    return axios.delete('logout')
      .then(response => {
        return response.data.success
      })
  },
  resetAuth ({commit}) {
    commit('resetUser')
    resetAuth()
  }
}
const getters = {
  currentToken: (state) => {
    return state.currentToken
  },
  getUserFullName: (state) => {
    let fullName = ''
    if (!state.user) {
      return fullName
    }
    if (state.user.full_name) {
      fullName = state.user.full_name
    }
    return fullName
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
